import styled from 'styled-components'

import { GROUP_HEADER_TOP } from '../tab-card/tab-card.constants'

export const FieldsTable = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
  // Note: `clip` (not `hidden`) keeps the rounded corners without creating a scroll container,
  // which would stop the group headers from sticking to the page scroll
  overflow: 'clip',
  // Note: lets a stuck group header paint over the table's own 1px border
  overflowClipMargin: theme.border.size['1'],
}))

export const FieldGroup = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

// Note: the background lives on `::before` so that, while the header is stuck, it can turn into the
// rounded top of the table (border + top radius). `::after` is a white patch behind it that hides the
// table's own square side borders outside the rounded corners.
export const FieldGroupHeader = styled.div(({ theme }) => ({
  // Note: `&&` raises specificity so these win over the base rules whatever the key order
  '@container scroll-state(stuck: top)': {
    '&&::after': {
      display: 'block',
    },
    '&&::before': {
      border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
      borderBottom: 'none',
      borderRadius: `${theme.border.radius['8']} ${theme.border.radius['8']} 0 0`,
      left: `calc(-1 * ${theme.border.size['1']})`,
      right: `calc(-1 * ${theme.border.size['1']})`,
    },
  },
  '&::after': {
    background: theme.colors.white,
    content: '""',
    display: 'none',
    height: theme.border.radius['8'],
    left: `calc(-1 * ${theme.border.size['1']})`,
    position: 'absolute',
    right: `calc(-1 * ${theme.border.size['1']})`,
    top: 0,
    zIndex: -2,
  },
  '&::before': {
    background: theme.colors.gray200,
    bottom: 0,
    content: '""',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: -1,
  },
  alignItems: 'center',
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  color: theme.colors.primary600,
  // Note: scroll-state is newer than the csstype union
  containerType: 'scroll-state' as never,
  display: 'flex',
  fontSize: '1.2rem',
  fontWeight: 600,
  gap: theme.space['8'],
  justifyContent: 'space-between',
  padding: `${theme.space['6']} ${theme.space['16']}`,
  position: 'sticky',
  top: GROUP_HEADER_TOP,
  zIndex: 1,
}))
